import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

// text,email,tel,textarea,password,
@Component({
  selector: 'app-number',
  template: `
    <div [formGroup]="form">
      <input
        [attr.type]="'number'"
        class="form-control"
        [id]="field.name"
        [name]="field.name"
        [formControlName]="field.formControlName"
        [placeholder]="field.placeHolder"
      />
    </div>
  `,
  // styles: [
  //   `
  //     .form-control {
  //       border: 1px solid gray;
  //       height: 1.6rem;
  //       width: 15rem;
  //       font-size: 1rem;
  //       border-radius: 22px;
  //       padding-left: 12px;
  //       padding-right: 12px;
  //     }
  //   `,
  // ],
})
export class NumberComponent {
  @Input() field: any = {};
  @Input() form: FormGroup;
  get isValid() {
    return this.form.controls[this.field.formControlName].valid;
  }
  get isDirty() {
    return this.form.controls[this.field.formControlName].dirty;
  }

  constructor() {}
}
